import { DEFAULT_TIMEZONE, SYSTEM_CONFIGURATION_KEYS } from "../constants";
import type { SystemConfiguration } from "../services/common/type/common.type";
import type { SystemProfileSettings } from "../type/type";

const getTrimmedSettingValue = (value?: string | null): string | undefined => {
  const trimmedValue = value?.trim();

  return trimmedValue ? trimmedValue : undefined;
};

export const getSystemProfileSettings = (
  configurations?: SystemConfiguration[] | null,
): SystemProfileSettings => {
  const profileConfiguration = configurations?.find(
    (config) =>
      config.configuration_name ===
      SYSTEM_CONFIGURATION_KEYS.systemProfileConfiguration,
  );

  if (!profileConfiguration?.configuration_value) {
    return {};
  }

  try {
    return JSON.parse(
      profileConfiguration.configuration_value,
    ) as SystemProfileSettings;
  } catch {
    return {};
  }
};

export const getSystemDefaultTimezone = (
  configurations?: SystemConfiguration[] | null,
): string | undefined => {
  return getTrimmedSettingValue(
    getSystemProfileSettings(configurations).defaultTimezone,
  );
};

export const getSystemThemeColor = (
  configurations?: SystemConfiguration[] | null,
): string | undefined => {
  return getTrimmedSettingValue(
    getSystemProfileSettings(configurations).themeColor,
  );
};

export const resolveTimezone = (timezone?: string | null): string => {
  return getTrimmedSettingValue(timezone) ?? DEFAULT_TIMEZONE;
};

export const resolveActiveTimezone = (
  userTimezone?: string | null,
  systemTimezone?: string | null,
): string => {
  return (
    getTrimmedSettingValue(userTimezone) ?? resolveTimezone(systemTimezone)
  );
};
